export const homeserveConfiguration = {
  homeserve_configurations: `HomeServe Configuraciones`,
};
